import { Breakpoints, CTA, Layout } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { WizardViewProps } from './WizardViewProps';
import { StepsNavigation } from './StepsNavigation/StepsNavigation';

const StyledStepsNavigationWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.size.dynamic0150};
`;
const StyledButtonsWrapper = styled.div<{ singleButton: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.static400};
  margin-top: ${(props) => props.theme.size.dynamic0250};

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: ${(props) => (props.singleButton ? 'row' : 'row-reverse')};
    justify-content: space-between;
    gap: 0;
  }
`;

export function WizardVwView({
  currentStep,
  nextStep,
  previousStep,
  disabled,
  onNextClick,
  onPreviousClick,
  children,
}: WizardViewProps): ReactElement {
  return (
    <Layout allowOverflowingContent>
      <StyledStepsNavigationWrapper>
        <StepsNavigation currentStep={currentStep} />
      </StyledStepsNavigationWrapper>
      {children}
      <StyledButtonsWrapper singleButton={!(nextStep !== null && previousStep != null)}>
        {nextStep !== null && (
          <CTA tag="button" onClick={onNextClick} disabled={disabled}>
            Next
          </CTA>
        )}
        {previousStep !== null && (
          <CTA emphasis="secondary" tag="button" onClick={onPreviousClick}>
            Back
          </CTA>
        )}
      </StyledButtonsWrapper>
    </Layout>
  );
}
